import moment from "moment";
import React from "react";
import Timer from "../../../../../../components/ui/Timer";

interface Props {
  cancelSuccess: boolean;
  errorText: string | null;
  refund: { refund_amount: number } | null;
  closeModal: () => void;
  handleCancelBooking: () => void;
}

const CancellationModalContent: React.FC<Props> = ({
  cancelSuccess,
  errorText,
  refund,
  closeModal,
  handleCancelBooking,
}) => (
  <>
    {cancelSuccess || errorText ? (
      <div className="my-8 text-center">
        <span className="mt-4 text-6xl" role="img" aria-label={"Sad Emoji"}>
          😔
        </span>
        <h4 className="mt-4 font-medium text-primary text-md">
          Your booking has been cancelled.
        </h4>
        <p className="mt-2 text-sm font-medium text-orange">
          Check your email for details.
        </p>
        <p className="mt-2 text-sm text-text">
          <b>Note:</b> You will receive your refund in your source account
          within 24 hours
        </p>
        <div className="mx-20">
          <button
            type="button"
            onClick={closeModal}
            className="w-full px-6 py-3 mt-8 text-sm font-medium text-white border rounded-lg outline-none bg-orange border-orange hover:bg-orange"
          >
            Got it
          </button>
        </div>
      </div>
    ) : (
      <>
        <div className="my-4 text-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="inline w-16 fill-red-500"
            viewBox="0 0 286.054 286.054"
          >
            {/* SVG path */}
          </svg>
          <h4 className="mt-4 font-medium text-primary text-md">
            Clicking the Confirm button will permanently cancel your booking.
          </h4>
          <p className="mt-2 text-sm font-medium text-orange">
            Are you sure to proceed?
          </p>
          <Timer
            dateObject={moment(moment()).add(1, "minutes").toISOString()}
            onTimerEnd={closeModal}
          />
        </div>
        <div className="relative p-4 font-sans text-base antialiased font-light leading-relaxed border-t border-b border-t-blue-gray-100 border-b-blue-gray-100 text-blue-gray-500">
          After clicking on confirm button your booking will be cancel. and you
          can not revert this booking
        </div>
        <div className="flex my-4">
          <span className="flex-1 text-sm font-medium text-primary">
            Refund Amt
          </span>
          <span className="text-sm font-medium text-primary">
            ₹{refund?.refund_amount}
          </span>
        </div>
        <div className="flex gap-4 mt-8 max-sm:flex-col">
          <button
            onClick={closeModal}
            type="button"
            className="px-6 py-4 rounded-lg w-full text-[#333] text-sm font-medium border-none outline-none bg-gray-200 hover:bg-gray-300 active:bg-gray-200"
          >
            I am not sure
          </button>
          <button
            onClick={handleCancelBooking}
            type="button"
            className="w-full px-6 py-4 text-sm font-medium text-white border-none rounded-lg outline-none bg-orange hover:bg-orange active:bg-orange"
          >
            Confirm
          </button>
        </div>
      </>
    )}
  </>
);

export default CancellationModalContent;
